import billing from './billing';
import profile from './profile';

export default {
  account: {
    tabs: {
      tab_1: 'Cuenta',
      tab_2: 'Plan',
      tab_3: 'Terminos y condiciones',
    },
    ...profile,
    ...billing,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/account/account.js